export default "__VITE_ASSET__zjLPRKdY__"